import Line from './Line';
import Circle from './Circle';

export { Line, Circle };

export default {
  Line: Line,
  Circle: Circle
};


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-progress/src/index.js
// module id = 840
// module chunks = 0